import { render } from "./PokemonHeader.vue?vue&type=template&id=42bfedac&scoped=true"
import script from "./PokemonHeader.vue?vue&type=script&lang=js"
export * from "./PokemonHeader.vue?vue&type=script&lang=js"

import "./PokemonHeader.vue?vue&type=style&index=0&id=42bfedac&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bfedac"]])

export default __exports__